//HELPERS
import { getTranslatedString } from 'helpers/i18n';

export const optionsMapping = [
  {
    key: 'admin',
    title: getTranslatedString('landlordPortal.users.form.admin.title'),
    description: getTranslatedString('landlordPortal.users.form.ifAdminEnabled'),
  },
  {
    key: 'can_manually_assign',
    title: getTranslatedString('landlordPortal.users.form.canManuallyAssignLabel'),
    description: getTranslatedString('landlordPortal.users.form.canManuallyAssignDescription'),
  },
  {
    key: 'notice_template_manager',
    title: getTranslatedString('landlordPortal.users.form.noticeTemplateLabel'),
    description: getTranslatedString('landlordPortal.users.form.noticeTemplateDescription'),
  },
  {
    key: 'can_only_send_by_notice_template',
    title: getTranslatedString('landlordPortal.users.form.canOnlySendByNoticeTemplateLabel'),
    description: getTranslatedString(
      'landlordPortal.users.form.canOnlySendByNoticeTemplateDescription'
    ),
  },
  {
    key: 'can_add_amenities',
    title: getTranslatedString('landlordPortal.users.form.canAddAmenitiesLabel'),
    description: getTranslatedString('landlordPortal.users.form.canAddAmenitiesDescription'),
  },
  {
    key: 'lease_signing_authority',
    title: getTranslatedString('landlordPortal.users.form.leaseSignAuthorityLabel'),
    description: getTranslatedString('landlordPortal.users.form.leaseSignAuthorityDescription'),
  },
  {
    key: 'lease_creation_authority',
    title: getTranslatedString('landlordPortal.users.form.leaseCreationAuthorityLabel'),
    description: getTranslatedString('landlordPortal.users.form.leaseCreationAuthorityDescription'),
  },
  {
    key: 'can_approve_leases',
    title: getTranslatedString('landlordPortal.users.form.leaseApprovalLabel'),
    description: getTranslatedString('landlordPortal.users.form.leaseApprovalDescription'),
  },
  {
    key: 'can_view_credit_check',
    title: getTranslatedString('landlordPortal.users.form.canViewCreditCheckLabel'),
    description: getTranslatedString('landlordPortal.users.form.canViewCreditCheckDescription'),
  },
  {
    key: 'can_approve_application',
    title: getTranslatedString('landlordPortal.users.form.canApproveApplicationLabel'),
    description: getTranslatedString('landlordPortal.users.form.canApproveApplicationDescription'),
  },
  {
    key: 'call_center',
    title: getTranslatedString('landlordPortal.users.form.callCenterLabel'),
    description: getTranslatedString('landlordPortal.users.form.callCenterDescription'),
  },
  {
    key: 'show_availability',
    title: getTranslatedString('landlordPortal.users.form.showAvailabilityLabel'),
    description: getTranslatedString('landlordPortal.users.form.showAvailabilityDescription'),
  },
  {
    key: 'allow_manual_agent_bookings',
    title: getTranslatedString('landlordPortal.users.form.manualBookingLabel'),
    description: getTranslatedString('landlordPortal.users.form.manualBookingDescription'),
  },
  {
    key: 'escalate_maintenance_tickets',
    title: getTranslatedString('landlordPortal.users.form.escalateTicketsLabel'),
    description: getTranslatedString('landlordPortal.users.form.escalateTicketsDescription'),
  },
  {
    key: 'receive_not_signed_up_leads_notification',
    title: getTranslatedString('landlordPortal.users.form.nonRegisteredTenantsLabel'),
    description: getTranslatedString('landlordPortal.users.form.nonRegisteredTenantsDescription'),
  },
  {
    key: 'is_manager',
    title: getTranslatedString('landlordPortal.users.form.isManagerLabel'),
    description: getTranslatedString('landlordPortal.users.form.isManagerDescription'),
  },
  {
    key: 'enable_two_factor_auth',
    title: getTranslatedString('landlordPortal.users.form.twoFactorLabel'),
    description: getTranslatedString('landlordPortal.users.form.twoFactorDescription'),
  },
  {
    key: 'maintenance_notifications',
    title: getTranslatedString('landlordPortal.users.form.serviceRequestNotificationsLabel'),
    description: getTranslatedString(
      'landlordPortal.users.form.serviceRequestNotificationsDescription'
    ),
  },
  {
    key: 'can_assign_and_schedule_tickets',
    title: getTranslatedString('landlordPortal.users.form.assignAndScheduleTickets'),
    description: getTranslatedString(
      'landlordPortal.users.form.assignAndScheduleTicketsDescription'
    ),
  },
  {
    key: 'can_log_travel_and_work_times',
    title: getTranslatedString('landlordPortal.users.form.timeTracking'),
    description: getTranslatedString('landlordPortal.users.form.timeTrackingDescription'),
  },
  {
    key: 'can_change_ticket_status',
    title: getTranslatedString('landlordPortal.users.form.statusChange'),
    description: getTranslatedString('landlordPortal.users.form.statusChangeDescription'),
  },
  {
    key: 'read_only',
    title: getTranslatedString('landlordPortal.users.form.readOnlyLabel'),
    description: getTranslatedString('landlordPortal.users.form.readOnlyDescription'),
  },
  {
    key: 'hide_branding',
    title: getTranslatedString('landlordPortal.users.form.hideBrandingLabel'),
    description: getTranslatedString('landlordPortal.users.form.hideBrandingDescription'),
  },
  {
    key: 'claim_tickets',
    title: getTranslatedString('landlordPortal.users.form.claimTicketsLabel'),
    description: getTranslatedString('landlordPortal.users.form.claimTicketsDescription'),
  },
  {
    key: 'assign_tickets',
    title: getTranslatedString('landlordPortal.users.form.assignTicketsLabel'),
    description: getTranslatedString('landlordPortal.users.form.assignTicketsDescription'),
  },
  {
    key: 'view_all_tickets',
    title: getTranslatedString('landlordPortal.users.form.viewAllTicketsLabel'),
    description: getTranslatedString('landlordPortal.users.form.viewAllTicketsDescription'),
  },
  {
    key: 'view_non_maintenance_tickets',
    title: getTranslatedString('landlordPortal.users.form.viewNonMaintenanceTicketsLabel'),
    description: getTranslatedString(
      'landlordPortal.users.form.viewNonMaintenanceTicketsDescription'
    ),
  },
  {
    key: 'can_approve_purchase_order',
    title: getTranslatedString('landlordPortal.users.form.approvePurchaseOrders'),
    description: getTranslatedString('landlordPortal.users.form.approvePurchaseOrdersDescription'),
  },
];
